// Base Empty Search Filter.
const BaseFilter = {
  "topics": [], "approach": [], "diversity": []
};

// Export the Base Filter
export default BaseFilter;
